/* tslint:disable */
/* eslint-disable */
/**
 * Green0meter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateEuTaxonomyActivityCategoryDto } from '../models';
// @ts-ignore
import type { CreateEuTaxonomyActivityDto } from '../models';
// @ts-ignore
import type { EuTaxonomyActivityCategoryDto } from '../models';
// @ts-ignore
import type { EuTaxonomyActivityDto } from '../models';
/**
 * EuTaxonomyActivityApi - axios parameter creator
 * @export
 */
export const EuTaxonomyActivityApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateEuTaxonomyActivityDto} createEuTaxonomyActivityDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        euTaxonomyActivityControllerCreateEuTaxonomyActivity: async (createEuTaxonomyActivityDto: CreateEuTaxonomyActivityDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createEuTaxonomyActivityDto' is not null or undefined
            assertParamExists('euTaxonomyActivityControllerCreateEuTaxonomyActivity', 'createEuTaxonomyActivityDto', createEuTaxonomyActivityDto)
            const localVarPath = `/api/eu-taxonomy-activity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createEuTaxonomyActivityDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateEuTaxonomyActivityCategoryDto} createEuTaxonomyActivityCategoryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        euTaxonomyActivityControllerCreateEuTaxonomyActivityCategory: async (createEuTaxonomyActivityCategoryDto: CreateEuTaxonomyActivityCategoryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createEuTaxonomyActivityCategoryDto' is not null or undefined
            assertParamExists('euTaxonomyActivityControllerCreateEuTaxonomyActivityCategory', 'createEuTaxonomyActivityCategoryDto', createEuTaxonomyActivityCategoryDto)
            const localVarPath = `/api/eu-taxonomy-activity/category`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createEuTaxonomyActivityCategoryDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} categoryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        euTaxonomyActivityControllerGetEuTaxonomyActivities: async (categoryId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'categoryId' is not null or undefined
            assertParamExists('euTaxonomyActivityControllerGetEuTaxonomyActivities', 'categoryId', categoryId)
            const localVarPath = `/api/eu-taxonomy-activity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (categoryId !== undefined) {
                localVarQueryParameter['categoryId'] = categoryId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        euTaxonomyActivityControllerGetEuTaxonomyActivityCategories: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/eu-taxonomy-activity/category`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} activityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        euTaxonomyActivityControllerGetEuTaxonomyActivityDetail: async (activityId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'activityId' is not null or undefined
            assertParamExists('euTaxonomyActivityControllerGetEuTaxonomyActivityDetail', 'activityId', activityId)
            const localVarPath = `/api/eu-taxonomy-activity/{activityId}/detail`
                .replace(`{${"activityId"}}`, encodeURIComponent(String(activityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EuTaxonomyActivityApi - functional programming interface
 * @export
 */
export const EuTaxonomyActivityApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EuTaxonomyActivityApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateEuTaxonomyActivityDto} createEuTaxonomyActivityDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async euTaxonomyActivityControllerCreateEuTaxonomyActivity(createEuTaxonomyActivityDto: CreateEuTaxonomyActivityDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.euTaxonomyActivityControllerCreateEuTaxonomyActivity(createEuTaxonomyActivityDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EuTaxonomyActivityApi.euTaxonomyActivityControllerCreateEuTaxonomyActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateEuTaxonomyActivityCategoryDto} createEuTaxonomyActivityCategoryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async euTaxonomyActivityControllerCreateEuTaxonomyActivityCategory(createEuTaxonomyActivityCategoryDto: CreateEuTaxonomyActivityCategoryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.euTaxonomyActivityControllerCreateEuTaxonomyActivityCategory(createEuTaxonomyActivityCategoryDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EuTaxonomyActivityApi.euTaxonomyActivityControllerCreateEuTaxonomyActivityCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} categoryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async euTaxonomyActivityControllerGetEuTaxonomyActivities(categoryId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EuTaxonomyActivityDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.euTaxonomyActivityControllerGetEuTaxonomyActivities(categoryId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EuTaxonomyActivityApi.euTaxonomyActivityControllerGetEuTaxonomyActivities']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async euTaxonomyActivityControllerGetEuTaxonomyActivityCategories(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EuTaxonomyActivityCategoryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.euTaxonomyActivityControllerGetEuTaxonomyActivityCategories(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EuTaxonomyActivityApi.euTaxonomyActivityControllerGetEuTaxonomyActivityCategories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} activityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async euTaxonomyActivityControllerGetEuTaxonomyActivityDetail(activityId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EuTaxonomyActivityCategoryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.euTaxonomyActivityControllerGetEuTaxonomyActivityDetail(activityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EuTaxonomyActivityApi.euTaxonomyActivityControllerGetEuTaxonomyActivityDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EuTaxonomyActivityApi - factory interface
 * @export
 */
export const EuTaxonomyActivityApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EuTaxonomyActivityApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateEuTaxonomyActivityDto} createEuTaxonomyActivityDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        euTaxonomyActivityControllerCreateEuTaxonomyActivity(createEuTaxonomyActivityDto: CreateEuTaxonomyActivityDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.euTaxonomyActivityControllerCreateEuTaxonomyActivity(createEuTaxonomyActivityDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateEuTaxonomyActivityCategoryDto} createEuTaxonomyActivityCategoryDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        euTaxonomyActivityControllerCreateEuTaxonomyActivityCategory(createEuTaxonomyActivityCategoryDto: CreateEuTaxonomyActivityCategoryDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.euTaxonomyActivityControllerCreateEuTaxonomyActivityCategory(createEuTaxonomyActivityCategoryDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} categoryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        euTaxonomyActivityControllerGetEuTaxonomyActivities(categoryId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<EuTaxonomyActivityDto>> {
            return localVarFp.euTaxonomyActivityControllerGetEuTaxonomyActivities(categoryId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        euTaxonomyActivityControllerGetEuTaxonomyActivityCategories(options?: RawAxiosRequestConfig): AxiosPromise<Array<EuTaxonomyActivityCategoryDto>> {
            return localVarFp.euTaxonomyActivityControllerGetEuTaxonomyActivityCategories(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} activityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        euTaxonomyActivityControllerGetEuTaxonomyActivityDetail(activityId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<EuTaxonomyActivityCategoryDto>> {
            return localVarFp.euTaxonomyActivityControllerGetEuTaxonomyActivityDetail(activityId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EuTaxonomyActivityApi - object-oriented interface
 * @export
 * @class EuTaxonomyActivityApi
 * @extends {BaseAPI}
 */
export class EuTaxonomyActivityApi extends BaseAPI {
    /**
     * 
     * @param {CreateEuTaxonomyActivityDto} createEuTaxonomyActivityDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EuTaxonomyActivityApi
     */
    public euTaxonomyActivityControllerCreateEuTaxonomyActivity(createEuTaxonomyActivityDto: CreateEuTaxonomyActivityDto, options?: RawAxiosRequestConfig) {
        return EuTaxonomyActivityApiFp(this.configuration).euTaxonomyActivityControllerCreateEuTaxonomyActivity(createEuTaxonomyActivityDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateEuTaxonomyActivityCategoryDto} createEuTaxonomyActivityCategoryDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EuTaxonomyActivityApi
     */
    public euTaxonomyActivityControllerCreateEuTaxonomyActivityCategory(createEuTaxonomyActivityCategoryDto: CreateEuTaxonomyActivityCategoryDto, options?: RawAxiosRequestConfig) {
        return EuTaxonomyActivityApiFp(this.configuration).euTaxonomyActivityControllerCreateEuTaxonomyActivityCategory(createEuTaxonomyActivityCategoryDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} categoryId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EuTaxonomyActivityApi
     */
    public euTaxonomyActivityControllerGetEuTaxonomyActivities(categoryId: string, options?: RawAxiosRequestConfig) {
        return EuTaxonomyActivityApiFp(this.configuration).euTaxonomyActivityControllerGetEuTaxonomyActivities(categoryId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EuTaxonomyActivityApi
     */
    public euTaxonomyActivityControllerGetEuTaxonomyActivityCategories(options?: RawAxiosRequestConfig) {
        return EuTaxonomyActivityApiFp(this.configuration).euTaxonomyActivityControllerGetEuTaxonomyActivityCategories(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} activityId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EuTaxonomyActivityApi
     */
    public euTaxonomyActivityControllerGetEuTaxonomyActivityDetail(activityId: string, options?: RawAxiosRequestConfig) {
        return EuTaxonomyActivityApiFp(this.configuration).euTaxonomyActivityControllerGetEuTaxonomyActivityDetail(activityId, options).then((request) => request(this.axios, this.basePath));
    }
}

